export default "__VITE_ASSET__CwGzjjEG__"